export const SESSION_STORAGE_ACCESS_TOKEN = 'sj_token';
export const SESSION_STORAGE_REFRESH_TOKEN = 'sj_refresh_token';
export const SESSION_STORAGE_USER = 'sj_user';
export const SESSION_STORAGE_LAST_ACTIVITY = 'last_activity';
